import { render, staticRenderFns } from "./efItem8.vue?vue&type=template&id=e3d13692&lang=pug&"
import script from "./efItem8.vue?vue&type=script&lang=js&"
export * from "./efItem8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports